import { createContext, useContext } from 'react';

import { PatronSessionState } from '@app/components';
import { authenticateToken } from '@app/hooks';
import { SetState } from '@app/constants';

export interface AppContextProps {
  locale: string;
  patronSession: PatronSessionState;
  isLoggedIn: boolean;
  bannerMessage: string | undefined;
  authenticateToken: authenticateToken;
  setPatronSession: SetState<PatronSessionState>;
  setSelectedLocale: SetState<string>;
}

export const AppContext = createContext<AppContextProps>(null!);

export const useAppContext = (): AppContextProps => {
  return useContext(AppContext);
};
